export default {
  new(data) {
    this.name = data.name; // Feature Name
    this.values = data.values; // Added values
    return this;
  },
  name: null, // Feature Name
  values: [], // Added values
};
